import Swal from "sweetalert2";
import React, { useState, useContext } from "react";
import AppShell from "../components/AppShell";
import config from "../config";
import { UserContext } from "../components/MyContext";
import { FaUserCircle, FaKey } from "react-icons/fa";
import { RiLockPasswordFill, RiAccountCircleLine } from "react-icons/ri";
import { HiOutlineMail, HiOutlineOfficeBuilding, HiOutlineAcademicCap } from "react-icons/hi";
import axios from "axios";

function AccountSettings() {
  const { userData } = useContext(UserContext);

  const [password, setPassword] = useState({
    current: "",
    new: "",
    confirm: "",
  });

  const [activeTab, setActiveTab] = useState("profile");

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword({
      ...password,
      [name]: value,
    });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (password.new !== password.confirm) {
      Swal.fire("warning", "New passwords don't match", "warning");
      return;
    }
   
    const token = localStorage.getItem(config.token_name); 
    try {
      const res = await axios.post(`${config.urlApi}/change-password`,{
        token,
        currentPassword: password.current,
        newPassword: password.new
      });

      if (res.status === 200) {
        Swal.fire("Success", "Password updated successfully", "success");
        setPassword({
          current: "",
          new: "",
          confirm: "",
        });
      } else {
        Swal.fire("Error", res.data.message || "Failed to update password", "error");
      }

    } catch (error) {
      const errorMessage =
      error.response?.data?.message ||
      error.message || "Failed to update password";
      Swal.fire("Error", errorMessage, "error");
    }
  };

  return (
    <AppShell
      contentPreset="form"
      title="Account Settings"
      subtitle="ตรวจสอบข้อมูลบัญชีผู้ใช้งานและการตั้งค่าความปลอดภัยของระบบ"
    >
      <div className="container-fluid py-2">
        <div className="row">
          <div className="col-12">
            <div className="card shadow-sm mb-4">
              <div className="card-body p-0">
                <div className="row g-0">
                  <div className="col-md-4 border-end">
                    <div className="d-flex flex-column align-items-center text-center p-4">
                      <div className="avatar-upload mb-3 position-relative">
                        {userData.logo ? (
                          <img
                            src={`${config.urlApi}/logos/${userData.logo}`}
                            alt="User"
                            className="rounded-circle shadow"
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <FaUserCircle
                            className="text-primary"
                            size={150}
                            style={{
                              filter:
                                "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
                            }}
                          />
                        )}
                      </div>
                      <div className="d-flex flex-column align-items-center">
                        <span className="fw-semibold fs-4 mb-1">
                          {userData.campusName}
                        </span>
                        <span className="text-muted fs-5 mb-3">
                          {userData.facultyName}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="p-4">
                      <ul className="nav nav-tabs mb-4">
                        <li className="nav-item">
                          <button
                            className={`nav-link ${
                              activeTab === "profile" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("profile")}
                          >
                            Profile
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            className={`nav-link ${
                              activeTab === "password" ? "active" : ""
                            }`}
                            onClick={() => setActiveTab("password")}
                          >
                            Password
                          </button>
                        </li>
                      </ul>

                      {activeTab === "profile" ? (
                        <div className="profile-tab">
                          <div className="profile-info">
                            <div className="info-item">
                              <div className="progile-title">
                                <HiOutlineMail className="info-icon" />
                                <span className="info-label">Email : </span>
                              </div>
                              <span className="info-value">{userData.email}</span>
                            </div>
                            <div className="info-item">
                              <div className="progile-title">
                                <RiAccountCircleLine className="info-icon" />
                                <span className="info-label">Full Name : </span>
                              </div>
                              <span className="info-value">{userData.firstname} {userData.surname}</span>
                            </div>
                            <div className="info-item">
                              <div className="progile-title">
                                <HiOutlineOfficeBuilding className="info-icon" />
                                <span className="info-label">Campus Name : </span>
                              </div>
                              <span className="info-value">{userData.campusName}</span>
                            </div>
                            <div className="info-item">
                              <div className="progile-title">
                                <HiOutlineAcademicCap className="info-icon" />
                                <span className="info-label">Faculty Name : </span>
                              </div>
                              <span className="info-value">{userData.facultyName}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="password-tab">
                          <form onSubmit={handlePasswordSubmit}>
                            <div className="mb-3">
                              <label className="form-label">
                                Current Password
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <RiLockPasswordFill />
                                </span>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="current"
                                  value={password.current}
                                  onChange={handlePasswordChange}
                                  placeholder="Enter current password"
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">
                                New Password
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <FaKey />
                                </span>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="new"
                                  value={password.new}
                                  onChange={handlePasswordChange}
                                  placeholder="Enter new password"
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="mb-4">
                              <label className="form-label">
                                Confirm New Password
                              </label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <FaKey />
                                </span>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="confirm"
                                  value={password.confirm}
                                  onChange={handlePasswordChange}
                                  placeholder="Re-enter new password"
                                  disabled
                                />
                              </div>
                            </div>
                            <button
                              type="submit"
                              className="btn btn-primary w-100"
                              disabled
                            >
                              Update Password
                            </button>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
}

export default AccountSettings;
